import React, { useState, useEffect } from 'react'
import Chart from 'react-apexcharts'

import { Card, Form, Table, Typography } from 'antd'

import EmptyData from '../../../assets/images/ico_dashboard.svg'
import { getMessage } from '../../../util/IntlMessages'
import sortText from '../../../util/sortText'
import ChartHeader from '../../Dashboard/Cultivars/charts/ChartHeader'
import './PopulationAndProductivity.css'

const PopulationAndProductivity = ({ values }) => {
  const [formValues] = useState({})

  const [totalFields, setTotalFields] = useState(0)

  const [formattedData, setFormattedData] = useState([])

  const [report, setReport] = useState([])

  const [hasData, setHasData] = useState(false)

  useEffect(() => {
    if (values) {
      const range = Object.values(values)
      handleValues(range)
    } else {
      setHasData(false)
      setTotalFields(0)
    }
  }, [values])

  const handleValues = (range) => {
    if (range.length === 0) return

    const productivity = []
    const camps = []

    range.reverse().forEach((round) => {
      const qttCamps = round.length
      const prod = round.reduce((acc, item) => acc + item.productivity, 0) / qttCamps || 0
      camps.push(qttCamps)
      productivity.push(parseInt(prod))
    })

    setReport([
      {
        name: 'Produtividade sc/ha',
        data: productivity
      },
      {
        name: 'Quantidade de campos',
        data: camps
      }
    ])

    const arraysMixed = Array.prototype.concat.apply([], range)

    const filteredData = arraysMixed.filter(
      ({ environment_productive_planting, epoc }) => environment_productive_planting && epoc
    )

    if (filteredData.length > 0) setHasData(true)

    const responseAggregateTotalCamps = aggregateTotalCamps(filteredData)

    setFormattedData(responseAggregateTotalCamps.aggregateCamps)
    setTotalFields(responseAggregateTotalCamps.totalCamps)
  }

  let ids = []
  const aggregateTotalCamps = (camps) => {
    const reducedCamps = camps.reduce((acc, val) => {
      if (ids.includes(val.action_id)) return acc
      ids.push(val.action_id)

      const { environment_productive_planting, epoc } = val
      const key = `${environment_productive_planting}_${epoc}`
      const data = acc[key] || { environment_productive_planting, epoc, field: 0 }
      data.field++
      return { ...acc, [key]: data }
    }, {})

    return { aggregateCamps: Object.values(reducedCamps), totalCamps: ids.length }
  }

  const options = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false
      }
    },
    colors: ['#04D1D1', '#843EF7'],
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      enabled: true,
      offsetX: 20,
      style: {
        fontSize: '12px',
        colors: ['#04D1D1', '#843EF7']
      }
    },
    stroke: {
      show: false
    },
    tooltip: {
      enabled: false
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left'
    },
    xaxis: {
      categories: ['320 a 280', '280 a 240', '240 a 200', '200 a 160']
    }
  }

  const getColorToEnvironment = (environment) => {
    if (environment === 'Baixa') {
      return 'env-low'
    } else if (environment === 'Média') {
      return 'env-average'
    } else {
      return 'env-high'
    }
  }

  const getColorToEpoc = (epoc) => {
    if (epoc === 'Abertura') {
      return 'epoc-opening'
    } else if (epoc === 'Intermediário') {
      return 'epoc-intermediary'
    } else if (epoc === 'Fechamento') {
      return 'epoc-closure'
    }
  }

  const getColumns = () => [
    {
      title: 'Repetições',
      sorter: (a, b) => sortText(a, b, 'field'),
      width: '40%',
      render: (item) => <p className="text2">{item.field}</p>
    },
    {
      title: 'Época',
      sorter: (a, b) => sortText(a, b, 'epoc'),
      width: '30%',
      render: (item) => (item.epoc !== null ? <p className={`text1 ${getColorToEpoc(item.epoc)}`}>{item.epoc}</p> : '-')
    },
    {
      title: 'Ambiente',
      sorter: (a, b) => sortText(a, b, 'environment_productive_planting'),
      width: '30%',
      render: (item) =>
        item.environment_productive_planting !== null ? (
          <p className={`text1 ${getColorToEnvironment(item.environment_productive_planting)}`}>
            {item.environment_productive_planting}
          </p>
        ) : (
          '-'
        )
    }
  ]

  if (Object.keys(formValues).length > 0) {
    const params = filterNormalize(formValues)

    const { materialsI2x, range } = params

    if (materialsI2x !== undefined) {
      const response = formattedData.map((f) => {
        if (f.material === materialsI2x) {
          return [f]
        }
      })

      const formattedResponse = response.filter((f) => f !== undefined)
      console.log(formattedResponse)
    }

    if (range !== undefined) {
      let n1 = Number(range.split(' a ')[1])
      let n2 = Number(range.split(' a ')[0])

      const response = formattedData.map((f) => {
        if (f.productivity >= n1 && f.productivity <= n2) {
          return [f]
        }
      })

      const formattedResponse = response.filter((f) => f !== undefined)
      console.log(formattedResponse)
    }
  }

  function filterNormalize(params) {
    const { materialsI2xFilter, rangeFilter } = params

    return {
      materialsI2x: materialsI2xFilter,
      range: rangeFilter
    }
  }

  return (
    <Card className="population-productivity">
      <ChartHeader title={getMessage('populationProductivity')} />

      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Form style={{ width: '100%', marginLeft: '-15px' }} layout="vertical">
          {/*<MaterialAndRangeFilter values={formValues} errors={errors} setFieldValueWithState={setFieldValueWithState} />*/}
        </Form>

        <Card style={{ width: '50%' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <p style={{ fontWeight: 'bold', fontSize: '14px' }}>Número total de campos</p>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px' }}>
                <p style={{ fontWeight: 'bold', color: '#843EF7', fontSize: '29px', margin: '0px' }}>{totalFields}</p>
              </div>
            </div>
          </div>
        </Card>
      </div>

      {hasData ? (
        <div className="content">
          <div className="right mr-10">
            <p className="subtitle">Produtividade e campos</p>
            <Chart options={options} series={report} type="bar" height="500" />
          </div>

          <div className="right ml-10">
            {formValues.rangeFilter ? (
              <p className="subtitle">{`Campos do Range de ${formValues.rangeFilter}`}</p>
            ) : (
              <p className="subtitle">{`Campos do Range`}</p>
            )}
            <Table columns={getColumns()} dataSource={formattedData} />
          </div>
        </div>
      ) : (
        <div style={{ width: '100%' }}>
          <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: 292 }}>
            <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
            <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 14 }}>
              {'Sem dados'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 14, marginTop: -50 }}
            >
              {'Escolha materiais para exibir'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 14, marginTop: -120 }}
            >
              {'esse relatório'}
            </Typography>
          </div>
        </div>
      )}
    </Card>
  )
}

export default PopulationAndProductivity
